import max from 'lodash-es/max';
import { Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from '../../../../node_modules/swiper/react/swiper-react.js';
import find from 'lodash-es/find';
import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import ProductTile from '../../components/React/ProductTile.jsx';
import AdMindClick from '../../components/AdMind/click';
import {
  getGraphIDFromProductId,
  getShopifyProductsForCountry,
} from '../../utils/retrieveShopifyProductsForSelectedCountry';

const getFirstVariantImageWithColor = (data, color) => {
  let img = null;

  for (let i = 0; i < data.Child_Attributes.length; i++) {
    const variant = data.Child_Attributes[i];

    try {
      if (variant.option1 === color) {
        img = variant.image_url.split('?')[0].replace('.jpg', '_600x.jpg').replace('.webp', '_600x.webp');
        break;
      }
    } catch (err) {
      console.log(err);
      console.log('ProdRecCarousel: Error in displaying var img');
    }
  }

  return img;
};

const getFirstVariantBarcodeWithColor = (data, color) => {
  let barcode = null;

  for (let i = 0; i < data.Child_Attributes.length; i++) {
    const variant = data.Child_Attributes[i];

    try {
      if (variant.option1 === color) {
        barcode = variant.barcode;
        break;
      }
    } catch (err) {
      console.log(err);
      console.log('ProdRecCarousel: Error in setting barcode');
    }
  }

  return barcode;
};

const getFirstAvailableVariant = (product) => {
  try {
    for (let i = 0; i < product.Child_Attributes.length; i++) {
      const variant = product.Child_Attributes[i];

      if (variant && variant.inventory && Number(variant.inventory) > 0) {
        return variant;
      }
    }
  } catch (error) {
    console.log('error - getFirstAvailableVariant:', error);
    return product.Child_Attributes[0];
  }
};

const getOptions = (data) => {
  const imgs = data.color.map((color) => {
    return getFirstVariantImageWithColor(data, color);
  });

  const Barcode = data.color.map((color) => {
    return getFirstVariantBarcodeWithColor(data, color);
  });

  const options = {
    Color: data.color,
    Size: data.size,
    imgs,
    Barcode,
  };

  return options;
};

const mapVariants = (variants) => {
  return variants.map((variant) => {
    return {
      ...variant,
      Sellable: Number(variant.inventory) > 0,
      imgs: variant.image_url,
      Color: variant.option1,
      id: variant.variant_id,
      'Product-sku': variant.sku ? variant.sku : '',
    };
  });
};

const maxRetries = 10;
let fallBackInterval;
let retryCount = 0;

const ProductRecommendationsCarousel = (props) => {
  const [items, setItems] = useState([]);
  const [title, setTitle] = useState('');
  const container = useRef(null);
  const flickity = useRef(null);

  const getCellAlignment = () => {
    try {
      if (props.cellAlign) {
        return props.cellAlign;
      }
    } catch (err) {
      console.error(err);
      console.error('ProdRecCarousel: Error in algnmnt carousel items');
    }

    // if ($(window).width() >= 998) {
    try {
      if (window.document.documentElement.clientWidth >= 998) {
        return 'center';
      }
    } catch (err) {
      console.error(err);
      console.error('ProdRecCarousel: Error in not reading window width');
    }

    return 'left';
  };

  const carouselOptions = {
    imagesLoaded: true,
    cellAlign: getCellAlignment(),
    contain: false,
    groupCells: 4,
    draggable: true,
    wrapAround: true,
    dragThreshold: 10,
    initialIndex: 0,
    prevNextButtons: true,
    pageDots: true,
  };

  const dispatchCarousel = () => {
    const carouselGo = new CustomEvent('carouselDidInit');
    document.dispatchEvent(carouselGo);
  };

  const clickTracking = (e, item) => {
    const firstVariant = item.Child_Attributes[0];
    const comparePrices = item.Child_Attributes.map((variant) => {
      return variant.compare_at_price;
    });
    const comparePriceMax = max(comparePrices);

    let currentTarget = e.currentTarget;
    let collectionName = currentTarget.closest('[data-collection]');
    let listName = '';

    if (collectionName) {
      listName = collectionName.dataset.collection;

      sessionStorage.setItem('rec_list_name', listName);

      const product = {
        id: item.item_group_id,
        title: item.Title,
        product_type: item.product_type,
        price: firstVariant.price,
        price_compare: firstVariant.compare_at_price,
        price_compare_max: comparePriceMax,
        tags: item.tags.split(','),
        variants: item.Child_Attributes,
        list_name: listName,
      };

      AdMindClick(product);
    }
  };

  const handleCertonaRecommendationsDidLoad = async () => {
    try {
      if (!window.certonaSchemes) {
        return;
      }
    } catch (err) {
      console.error(err);
      console.error('ProdRecCarousel: Error in certonaSchemes');
    }

    let recItems = [];

    try {
      if (window.certonaSchemes && window.certonaSchemes[props.scheme]) {
        recItems = window.certonaSchemes[props.scheme];

        if (window.theme.country_iso !== 'US') {
          const graph_product_ids = recItems.map((item) => {
            return getGraphIDFromProductId(item.product_id);
          });

          const final_items_list = [];
          try {
            const shopify_products = await getShopifyProductsForCountry(graph_product_ids);

            for (const product of shopify_products) {
              if (!product.variants) {
                console.error(`No variants found in Shopify for this product: ${product.id}`);
                continue;
              }
              const product_id_parts = product.id.split('/');
              const product_id = product_id_parts[product_id_parts.length - 1];
              const certona_product = find(recItems, {
                product_id,
              });
              if (!certona_product) {
                continue;
              }
              for (const variant of product.variants) {
                const variant_id_parts = variant.id.split('/');
                const variant_id = variant_id_parts[variant_id_parts.length - 1];
                const certona_variant = find(certona_product.Child_Attributes, {
                  variant_id,
                });
                if (!certona_variant) {
                  continue;
                }
                certona_variant.compare_at_price = variant.compareAtPrice.amount;
                certona_variant.price = variant.price.amount;
              }
              final_items_list.push(certona_product);
            }

            if (final_items_list.length === 0) {
              $(`.ProductRecommendationsCarousel__component[data-index="${props.index}"]`)
                .closest('.ProductRecommendationsCarousel')
                .hide();
            }
          } catch (error) {
            console.error(error);
          }
          recItems = final_items_list;
        }
      } else {
        return;
      }
    } catch (err) {
      console.error(err);
      console.error('ProdRecCarousel: Error in returning props schemes');
    }

    const filteredRecItems = recItems.filter((item) => {
      const availableVariants = item.Child_Attributes.filter((variant) => {
        return Number(variant.inventory) > 0;
      });

      return availableVariants.length > 0;
    });

    // Don't worry about multiples if there are no rec items
    if (filteredRecItems.length === 0) {
      return;
    }

    const containerWidth = container.current.clientWidth;
    const productTileWidth = 220 * filteredRecItems.length;
    const multiple = Math.ceil(containerWidth / productTileWidth);

    // console.log('multiple:', containerWidth, productTileWidth, multiple);

    try {
      if (multiple > 1) {
        let multipliedItems = [];

        for (let i = 0; i < multiple; i++) {
          multipliedItems = multipliedItems.concat(filteredRecItems);
        }

        setItems(multipliedItems);
      } else {
        setItems(filteredRecItems ? filteredRecItems : []);
      }
    } catch (err) {
      console.error(err);
      console.error('ProdRecCarousel: Error in returning rec items');
    }
  };

  const handleLoad = (event) => {
    setItems(event.detail.monetateData);
    setTitle(event.detail.title);
    if (event.detail.title) {
      document.querySelectorAll('.ProductRecommendationsCarousel__heading')[props.index].innerHTML = event.detail.title;
    }
  };

  useEffect(() => {
    document.addEventListener(`monetateLoaded${props.scheme}`, handleLoad);
    return () => {
      document.removeEventListener(`monetateLoaded${props.scheme}`, handleLoad);
    };
  }, []);

  return (
    <div>
      <div className="Section ProductRecommendationsCarousel__heading-section" data-index={props.index}>
        <div className="Section__container">
          <h3 className="ProductRecommendationsCarousel__heading h1">{title}</h3>
        </div>
      </div>
      <div className="ProductRecommendationsCarousel__component" ref={container} data-index={props.index}>
        {items && items.length > 0 && (
          <Swiper
            modules={[Navigation, Pagination]}
            navigation={props.index === 0}
            pagination={{
              clickable: true,
            }}
            slidesPerView={2}
            allowTouchMove={true}
            breakpoints={{
              // when window width is >= 640px
              767: {
                slidesPerView: props.index === 0 && props.isProductPage ? 4 : 'auto',
                loopedSlides: props.index === 1,
                spaceBetween: 20,
                slidesPerGroup: 4,
                allowTouchMove: props.scheme !== 'product1_rr',
              },
            }}
          >
            {items &&
              items.length > 0 &&
              items.map((item, i) => {
                if (!item.Child_Attributes) {
                  return null;
                }
                // Map the item options to match the Instant Search format
                const options = getOptions(item);

                const firstAvailableVariant = getFirstAvailableVariant(item);
                const comparePrices = item.Child_Attributes.map((variant) => {
                  return variant.compare_at_price;
                });
                const comparePriceMax = max(comparePrices);

                const productUrl = item.Detail_URL.replace('https://windsor-us.myshopify.com', '');
                let urlParams = null;
                if (productUrl) {
                  try {
                    const url = new URL(productUrl);
                    if (url.search) {
                      urlParams = new URLSearchParams(url.search);
                    }
                  } catch (error) {
                    console.error('Error constructing URL:', error);
                  }
                }
                let recToken = null;
                if (urlParams) {
                  recToken = urlParams.get('recToken');
                }

                return (
                  <SwiperSlide key={i} onClick={(e) => clickTracking(e, item)}>
                    <ProductTile
                      key={`TrendingCarousel__ProductTile-${item.ID}-${i}`}
                      variant_id={firstAvailableVariant.variant_id}
                      id={item.product_id}
                      pid={item.ID}
                      title={item.Title}
                      product_url={productUrl}
                      product_type={item.product_type}
                      thumb_url={firstAvailableVariant.image_url}
                      thumb_alt={item.Title}
                      price={firstAvailableVariant.price}
                      price_compare={firstAvailableVariant.compare_at_price}
                      price_compare_max={comparePriceMax}
                      tags={item.tags.split(',')}
                      variants={mapVariants(item.Child_Attributes)}
                      options={options}
                      isRec={true}
                      shouldReportClickToAdmind={false}
                      mobileStackStars={true}
                      selectedColor={item.selectedColor}
                      recToken={recToken}
                      index={i}
                    />
                  </SwiperSlide>
                );
              })}
          </Swiper>
        )}
      </div>
    </div>
  );
};

export default () => {
  document.querySelectorAll('[data-product-recommendations-carousel]').forEach((el, i) => {
    if (el.getAttribute('initialized') === 'true') {
      return;
    }

    let scheme = el.getAttribute('data-scheme');
    const cellAlign = el.getAttribute('data-cell-align');
    let productPage = false;

    if (scheme.indexOf('product') > -1) {
      productPage = true;
    }

    // if (window.optimizely_certona && certona.devicetype !== 'tablet') {
    //   if (window.optimizely_certona.product1 && scheme === 'product1_rr') {
    //     scheme = window.optimizely_certona.product1;
    //   }
    //   if (window.optimizely_certona.product2 && scheme === 'product2_rr') {
    //     scheme = window.optimizely_certona.product2;
    //   }
    // }

    ReactDOM.render(
      <ProductRecommendationsCarousel scheme={scheme} cellAlign={cellAlign} index={i} isProductPage={productPage} />,
      el,
    );

    el.setAttribute('initialized', 'true');
  });
};
